const LANGUAGES = ['en', 'ja'];

export default LANGUAGES;
